import { useEffect, useState } from "react";
import { getFooter } from "./components/actions";
import { Button, Card, Col, Row, Table } from "antd";
import FooterModal from "./components/modals/FooterModal";
import { BackBtn } from "../../components/commonComponents";

export default function FooterPage() {

    const [footer, setFooter] = useState([]);
    const [open, setOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editFooter, setEditFooter] = useState(null);
    const reload = () => {
        getFooter().then(setFooter).catch(error => {
            console.error(error);
        });
    }

    useEffect(() => {
        reload();
    }, []);

    const handleEdit = (item) => {
        setEditFooter(item);
        setEditModalOpen(true);
    }

    const columns = [
        {
            title: 'დასახელება',
            dataIndex: 'label',
            key: 'label',
        },
        {
            title: 'ბმული',
            dataIndex: 'website',
            key: 'website',
        },
        {
            title: 'FB',
            dataIndex: 'facebook',
            key: 'facebook',
        },
        {
            title: 'ინსტაგრამი',
            dataIndex: 'instagram',
            key: 'instagram',
        },
        {
            title: 'მოქმედება',
            dataIndex: 'action',
            key: 'action',
            render: (_, record) => (
                <Button type="primary" icon={<i className="fa-regular fa-pen-to-square"></i>} onClick={() => handleEdit(record)} />
            ),
        },
    ]

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'start', flexDirection: 'column' }}>
            <div>
                <BackBtn path='/admin' label='დაბრუნება' />
            </div>
            <Card
                title="ფუტერი"
                style={{width: '100%'}}
            >
                <Row>
                    <Col span={24} style={{ justifyContent: 'center', alignItems: 'center' }}>
                        <Button type="primary" style={{ marginBottom: 10 }} icon={<i className="fa-solid fa-link"></i>} onClick={() => setOpen(true)} >
                            დამატება
                        </Button>
                    </Col>
                    <Col span={24}>
                        <div>
                            <Table
                                bordered
                                dataSource={footer}
                                columns={columns}
                                pagination={false}
                                scroll={{ x: 1000 }}
                                rowKey={record => record.id}
                            />
                        </div>
                    </Col>
                </Row>
                {
                    open && <FooterModal open={open} close={setOpen} reload={reload} />
                }
                {
                    editModalOpen && <FooterModal open={editModalOpen} close={setEditModalOpen} reload={reload} editFooter={editFooter} setEditFooter={setEditFooter} />
                }
            </Card>
        </div>
    )
}